import { createContext } from 'react';

const MissingProductsContext = createContext({
    missingProducts: [],
    setMissingProducts: () => {},
});

export default MissingProductsContext;
